/**
 * @generated SignedSource<<cbf1aad99ecc63b20c1e776a87a519cb>>
 * @relayHash 2c87c0157cc59e97287cf8d1dc172f27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0215005831383689216b9ff97db212400ee6d48ca84a9b8f006f22bb5101153d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchHierarchyEnabledInput = {
  hierarchyEnabled: boolean;
  viewId: string;
};
export type ui_useSetIssueSearchHierarchyEnabledMutation$variables = {
  input: JiraSetIssueSearchHierarchyEnabledInput;
};
export type ui_useSetIssueSearchHierarchyEnabledMutation$data = {
  readonly jira_setIssueSearchHierarchyEnabled: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type ui_useSetIssueSearchHierarchyEnabledMutation = {
  response: ui_useSetIssueSearchHierarchyEnabledMutation$data;
  variables: ui_useSetIssueSearchHierarchyEnabledMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraSetIssueSearchHierarchyEnabledPayload",
    "kind": "LinkedField",
    "name": "jira_setIssueSearchHierarchyEnabled",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_useSetIssueSearchHierarchyEnabledMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_useSetIssueSearchHierarchyEnabledMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0215005831383689216b9ff97db212400ee6d48ca84a9b8f006f22bb5101153d",
    "metadata": {},
    "name": "ui_useSetIssueSearchHierarchyEnabledMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "62d75d26ca70a6a2595d183cc6acca54";

export default node;
